import useScrollLock from '../../utils/useScrollLock';

/*
  Confirmation dialog for destructive actions.
  Usage:
    <ConfirmDialog
      open={!!target}
      title="Delete product?"
      message={`"${target?.name}" will be permanently removed.`}
      confirmLabel="Delete"
      onConfirm={...}
      onCancel={...}
    />
*/
export default function ConfirmDialog({
  open,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = true,
  busy = false,
  onConfirm,
  onCancel,
}) {
  useScrollLock(open);

  if (!open) return null;

  return (
    <div className="admin-modal-overlay" onClick={busy ? undefined : onCancel}>
      <div
        className="admin-modal admin-confirm"
        onClick={(e) => e.stopPropagation()}
      >
        <h3>{title}</h3>
        {message && <p className="confirm-message">{message}</p>}
        <div className="admin-modal-actions">
          <button className="btn-ghost" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            className={danger ? 'btn-danger' : 'btn-primary'}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? 'Working…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
